module.exports = __webpack_public_path__ + "img/people-01.31e8ad7c.png";